import { Component, OnInit } from '@angular/core';
import { MenuItems } from '../../../Core/Menu/MenuItems/MenuItems';
import { Router, NavigationEnd } from '@angular/router';
import { DropletService } from '../../../Services/Droplet.service';
import { InitProvider } from '../../../init-provider';
import { LevelService } from '../../../Services/level.service';

@Component({
  selector: 'app-footer-one',
  templateUrl: './FooterOne.component.html',
  styleUrls: ['./FooterOne.component.scss']
})
export class FooterOneComponent implements OnInit {
  currentUrl: any;
  socialIcons: any;
  company: any;
  faq: any;

  /** Footer navigation links (matches the institutional design) */
  navLinks = [
    { label: 'Home', url: '/home' },
    { label: 'Inscripciones', url: '/inscriptions' },
    { label: 'Institución', url: '/history-presence' },
  ];

  /** Educational levels listed in the footer's left column.
   *  Populated from GET /public/levels so each one links to its profile. */
  levelLinks: { label: string; url: string }[] = [];

  /** External link to the Cuadernito platform login */
  cuadernitoUrl = 'https://sanjoseadoratricessf.edu.ar/login';

  address1 = 'Blvd. Gálvez 1978';
  address2 = 'S3000 ACY, Santa Fe 3910';
  phone = '+543424538271';
  contactLink = '#contact';

  constructor(
    public footerMenu: MenuItems,
    private router: Router,
    public service: DropletService,
    public initProvider: InitProvider,
    private levelService: LevelService
  ) {
    // social icons content
    this.company = this.initProvider.getSettings();
    this.faq = JSON.parse(this.company.faq_json);
    //console.log(' this.faq', this.faq)
  }

  ngOnInit() {
    this.router.events
      .subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.currentUrl = event.url;
      }
    });
    this.currentUrl = this.router.url;
    this.loadLevels();
  }

  /** Load the educational levels so the footer links to each level profile. */
  private async loadLevels(): Promise<void> {
    try {
      const res = await this.levelService.getLevels();
      // GET /public/levels returns { data: { data: [...] } }; be defensive.
      const list = Array.isArray(res?.data?.data)
        ? res.data.data
        : Array.isArray(res?.data)
          ? res.data
          : [];
      this.levelLinks = list.map((level: any) => ({
        label: level.name,
        url: '/level-profile/' + level.id
      }));
    } catch {
      this.levelLinks = [];
    }
  }
}
